import React, { useState } from "react";

// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { ButtonNoShadow } from "../styled/button";
// ICONS
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
// COLORS
import { green, grey } from "@mui/material/colors";
import TextField from "@mui/material/TextField";
import { validateString } from "../../common/validators";
import { CustomModalRoot } from "../styled/modal";
import { LightGreyBox } from "../styled";

const MINIMUM_CHARACTERS = 15;

export default function ConfirmModal({
  show,
  action,
  label,
  message,
  closeModal,
  needConfirmationText,
  confirmationText,
  setConfirmationText,
  backBtnLabel = "Voltar",
  confirmBtnLabel = "Continuar",
}) {
  const [submitted, setSubmitted] = useState(false);
  const [isConfirmationTextValid, setIsConfirmationTextValid] = useState(true);

  const handleCloseModal = (e) => {
    closeModal && closeModal({}, e);
  };

  const handleAction = () => {
    setSubmitted(true);
    if (needConfirmationText) {
      const isValid = validateString(confirmationText, 15);
      if (!isValid) {
        setIsConfirmationTextValid(false);
        return;
      }
    }

    action();
  };

  return (
    <Modal
      aria-labelledby="alert-modal"
      aria-describedby="shows-alert-message"
      open={show}
      onClose={handleCloseModal}
      closeAfterTransition
      sx={{
        zIndex: 9999999,
        border: "none",
        "&:focus-visible": {
          border: "none",
        },
      }}
    >
      <Fade in={show}>
        <CustomModalRoot
          top={40}
          left={50}
          width={35}
          height={"auto"}
          maxheight={90}
        >
          <Box sx={{ p: 2 }}>
            <Typography
              id="alert-modal-title"
              variant="h6"
              align="center"
              fontWeight="bold"
            >
              {label}
            </Typography>

            <Divider sx={{ my: 2 }} />

            <LightGreyBox>
              <Typography
                id="alert-modal-message"
                variant="subtitle1"
                align="center"
              >
                {message}
              </Typography>
            </LightGreyBox>

            {needConfirmationText && (
              <Box sx={{ my: 2 }}>
                <TextField
                  id="cancel-description"
                  label="Motivo do Cancelamento"
                  multiline
                  rows={2}
                  value={confirmationText}
                  style={{ width: "100%" }}
                  onChange={(e) => {
                    setConfirmationText(e.target.value);
                  }}
                  error={!isConfirmationTextValid && submitted}
                  helperText={
                    !isConfirmationTextValid && submitted
                      ? `Mínimo de ${MINIMUM_CHARACTERS} caracteres necessários`
                      : `Mínimo de ${MINIMUM_CHARACTERS} caracteres`
                  }
                />
              </Box>
            )}
          </Box>

          <Box
            sx={{
              p: 2,
              mt: 3,
              mb: 1,
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <ButtonNoShadow
              width="60%"
              size="large"
              startIcon={<KeyboardBackspaceIcon />}
              fontWeight="bold"
              backgroundColor={grey["300"]}
              borderBottomRightRadius={0}
              borderTopRightRadius={0}
              onClick={closeModal}
            >
              {backBtnLabel}
            </ButtonNoShadow>
            <ButtonNoShadow
              width="40%"
              size="large"
              endIcon={<ThumbUpAltIcon />}
              textColor={grey["50"]}
              fontWeight="bold"
              backgroundColor={green["500"]}
              backgroundColorHover={green["400"]}
              borderBottomLeftRadius={0}
              borderTopLeftRadius={0}
              onClick={handleAction}
            >
              {confirmBtnLabel}
            </ButtonNoShadow>
          </Box>
        </CustomModalRoot>
      </Fade>
    </Modal>
  );
}
